import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '分类导航',
    links: [
      { to: '/category/core-value', label: '核心价值' },
      { to: '/category/usage-scenarios', label: '使用场景' },
      { to: '/category/real-experience', label: '真实体验' },
      { to: '/category/in-depth-review', label: '深度评测' },
      { to: '/category/cultural-insight', label: '文化洞见' },
    ],
  },
  {
    title: '关于我们',
    links: [
      { to: '/about', label: '品牌介绍' },
      { to: '/about#reputation', label: '用户口碑' },
      { to: '/about#contact', label: '联系我们' },
    ],
  },
  {
    title: '精选文章',
    links: [
      { to: '/article/the-beauty-within-exploring-the-core-value', label: '探寻核心价值' },
      { to: '/article/five-scenarios-in-daily-life', label: '五大使用场景' },
      { to: '/article/real-user-stories-collection', label: '真实用户故事' },
      { to: '/article/comprehensive-review-and-analysis', label: '全方位深度评测' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link
              to="/"
              className="flex items-center gap-2 text-xl font-heading text-background-50 mb-4"
            >
              <span className="w-8 h-8 flex items-center justify-center">
                <i className="ri-heart-3-fill text-xl"></i>
              </span>
              <span>掌中的美母</span>
            </Link>
            <p className="text-sm text-background-400 leading-relaxed">
              探索「掌中的美母」的独特魅力与深层内涵，发现属于您的专属感受。
            </p>
          </div>

          {footerLinks.map((section) => (
            <div key={section.title}>
              <h4 className="text-sm font-semibold text-background-50 mb-4">
                {section.title}
              </h4>
              <ul className="space-y-2">
                {section.links.map((link) => (
                  <li key={link.to}>
                    <Link
                      to={link.to}
                      className="text-sm text-background-400 hover:text-accent-400 transition-colors duration-200"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-background-700 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} 掌中的美母 版权所有
          </p>
          <div className="flex items-center gap-4">
            <span className="text-xs text-background-500">关注我们</span>
            <a href="#" className="w-8 h-8 flex items-center justify-center text-background-400 hover:text-accent-400 transition-colors duration-200" aria-label="微信">
              <i className="ri-wechat-line"></i>
            </a>
            <a href="#" className="w-8 h-8 flex items-center justify-center text-background-400 hover:text-accent-400 transition-colors duration-200" aria-label="微博">
              <i className="ri-weibo-line"></i>
            </a>
            <a href="#" className="w-8 h-8 flex items-center justify-center text-background-400 hover:text-accent-400 transition-colors duration-200" aria-label="小红书">
              <i className="ri-red-packet-line"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}